import { IMAGES } from "./content";
import { useInView } from "./useInView";

export const Histoires = () => {
  const [ref, cls] = useInView(0.15);
  return (
    <section id="histoires" ref={ref} className={`bg-mm-ink text-mm-paper py-24 md:py-32 ${cls}`} data-testid="histoires-section">
      <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        <figure className="reveal bg-mm-paper p-4">
          <img src={IMAGES.histoires} alt="Petites histoires pour de grandes questions : un enfant et un petit extraterrestre parmi les livres" className="w-full h-auto" loading="lazy" />
        </figure>
        <div className="min-w-0 reveal">
          <p className="mm-lab text-mm-goldlight">Petites histoires pour de grandes questions</p>
          <blockquote className="disp mt-6 mm-h2" data-testid="histoires-quote">
            « Ce qui est important ne se voit pas toujours, mais cela change tout. »
          </blockquote>
          <p className="mt-4 italic">Le Petit Prince</p>
          <p className="mm-body mt-10 text-mm-goldlight text-2xl italic">Prendre soin d'aujourd'hui pour transmettre demain.</p>
        </div>
      </div>
    </section>
  );
};
